import { InfoSet } from "../InfoSets/InfoSet";
import { HashSet } from "../Utils/HashSet";
import { Dictionary } from "../Utils/Dictionary";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { NumberUtils } from "../Utils/NumberUtils";
import { SnmpConstants } from "../Core/SnmpConstants";
import { IpSubnet } from "../Core/IpSubnet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface IpAddressEntryJsonWrapper {
//	ip_address_entry: IpAddressEntryJson;
//}

//export interface IpAddressEntryJson {
//	ip_address: string;
//	if_index: string;
//	type: string;
//	origin: string;
//	status: string;
//	mac_address: string;
//	net_mask: string;
//	prefix_length: string;
//}

export class IpAddressEntry implements ObjectSerializer {
	//public static FromJson(entry: IpAddressEntryJson): IpAddressEntry {
	//	var result = new IpAddressEntry(IpAddress.Create(entry.ip_address));

	//	if(entry.if_index !== undefined)
	//		result.IfIndex = NumberUtils.ToNumber(entry.if_index);

	//	if(entry.mac_address !== undefined)
	//		result.MacAddress = MacAddress.CreateFromString(entry.mac_address);

	//	if(entry.type !== undefined)
	//		result.AddressType = NumberUtils.ToNumber(entry.type);

	//	if(entry.origin !== undefined)
	//		result.Origin = NumberUtils.ToNumber(entry.origin);

	//	if(entry.status !== undefined)
	//		result.Status = NumberUtils.ToNumber(entry.status);

	//	if(entry.net_mask !== undefined)
	//		result.NetMask = IpAddress.Create(entry.net_mask);

	//	if(entry.prefix_length !== undefined)
	//		result.IpV6_PrefixLength = NumberUtils.ToNumber(entry.prefix_length);

	//	return result;
	//}

	public IpAddress: IpAddress;

	public IfIndex: number;
	public get HasIfIndex(): boolean {
		return this.IfIndex >= 0;
	}

	public AddressType: number;
	public get HasAddressType():boolean {
		return this.AddressType >= 0;
	}
		
	public AddressTypeToString(): string {
		return (SnmpConstants.IpAddressTypeToString(this.AddressType));
	}

	private _macAddress: MacAddress;
	public get MacAddress(): MacAddress {
		return this._macAddress;
	}

	public set MacAddress(value: MacAddress) {
		if (!value)
			this._macAddress = MacAddress.CreateNullAddress();
		else
			this._macAddress = value;
	}

	public get HasMacAddress(): boolean {
		if (this._macAddress != null) {
			return !this._macAddress.IsNull;
		}

		return false;
	}

	// IPv4 attributes
	public NetMask: IpAddress;
	public get HasNetMask():boolean {
		if(this.NetMask)
			return true;
		else
			return false;
	}

	// IPv6 attributes
	public IpV6_PrefixLength: number;
	public get HasIpV6_PrefixLength(): boolean {
		return this.IpV6_PrefixLength >= 0;
	}

	public Origin: number;
	public get HasOrigin(): boolean {
		return this.Origin >= 0;
	}

	public OriginToString(): string {
		return (SnmpConstants.IpAddressOriginToString(this.Origin));
	}

	public get IsDhcp(): boolean {
		return this.Origin == SnmpConstants.ipAddressOrigin_dhcp;
	}
	public set IsDhcp(value:boolean) {
		if (value)
			this.Origin = SnmpConstants.ipAddressOrigin_dhcp;
		else
			this.Origin = SnmpConstants.ipAddressOrigin_unknown;
	}

	public Status: number;
	public get HasStatus(): boolean {
		return this.Status >= 0;
	}
	
	public StatusToString(): string {
		return (SnmpConstants.IpAddressStatusToString(this.Status));
	}

	public get IpSubnet(): IpSubnet {
		if (this.IpAddress.IpVersion == IpVersion.IPv4 && this.HasNetMask)
			return IpSubnet.CreateFromAddresses(this.IpAddress, this.NetMask);

		return null;
	}

	constructor(ipAddress?: IpAddress) {
		this.IpAddress = ipAddress;
		this.IfIndex = -1;
		this.AddressType = -1;
		this.Origin = -1;
		this.Status = -1;
		this._macAddress = MacAddress.CreateNullAddress();

		// IPv4
		this.NetMask = null;

		// IPv6
		this.IpV6_PrefixLength = -1;
	}

	public Clone(cloneIp: IpAddress = null): IpAddressEntry {
		var newObject: IpAddressEntry = null;

		if (cloneIp != null)
			newObject = new IpAddressEntry(cloneIp);
		else
			newObject = new IpAddressEntry(this.IpAddress);

		newObject.IfIndex = this.IfIndex;
		newObject.AddressType = this.AddressType;

		if (this.HasMacAddress)
			newObject.MacAddress = this.MacAddress.Clone();

		if (this.HasNetMask)
			newObject.NetMask = this.NetMask.Clone();

		newObject.IpV6_PrefixLength = this.IpV6_PrefixLength;
		newObject.Origin = this.Origin;
		newObject.IsDhcp = this.IsDhcp;
		newObject.Status = this.Status;

		return (newObject);
	}

	public Write(obj: any, context: any): void {
		obj.ip_address_entry = {};
		obj = obj.ip_address_entry;

		obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasIfIndex)
			obj.if_index = ValueEncoder.EncodeInteger(this.IfIndex);

		if (this.HasAddressType)
			obj.type = ValueEncoder.EncodeInteger(this.AddressType);

		if (this.HasOrigin)
			obj.origin = ValueEncoder.EncodeInteger(this.Origin);

		if (this.HasStatus)
			obj.status = ValueEncoder.EncodeInteger(this.Status);

		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		// IPv4
		if (this.HasNetMask)
			obj.net_mask = ValueEncoder.EncodeIpAddress(this.NetMask);

		// IPv6
		if (this.HasIpV6_PrefixLength)
			obj.prefix_length = ValueEncoder.EncodeInteger(this.IpV6_PrefixLength);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_address_entry)
			throw new Error();
		obj = obj.ip_address_entry;

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.if_index !== undefined)
			this.IfIndex = ValueEncoder.DecodeInteger(obj.if_index);

		if (obj.type !== undefined)
			this.AddressType = ValueEncoder.DecodeInteger(obj.type);

		if (obj.origin !== undefined)
			this.Origin = ValueEncoder.DecodeInteger(obj.origin);

		if (obj.status !== undefined)
			this.Status = ValueEncoder.DecodeInteger(obj.status);

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.net_mask !== undefined)
			this.NetMask = ValueEncoder.DecodeIpAddress(obj.net_mask);

		if (obj.prefix_length !== undefined)
			this.IpV6_PrefixLength = ValueEncoder.DecodeInteger(obj.prefix_length);
	}
}

export class IpAddressTable extends InfoSet {
	//public static FromJson(json: InfoSetEntriesJson<IpAddressEntryJsonWrapper>, device: Device): IpAddressTable {
	//	var result = new IpAddressTable(device);

	//	json.entries.forEach((jsonEntry) => {
	//		result.AddEntry(IpAddressEntry.FromJson(jsonEntry.ip_address_entry));
	//	});

	//	return result;
	//}

	private _ipTable: Dictionary<IpAddress, IpAddressEntry>;

	constructor(device: Device) {
		super(device);
		this._ipTable = new Dictionary<IpAddress, IpAddressEntry>();
	}

	public Add(ipAddress: IpAddress): IpAddressEntry {
		var ipEntry: IpAddressEntry = null;

		if (this._ipTable.ContainsKey(ipAddress)) {
			ipEntry = this._ipTable.Item(ipAddress);
		}
		else {
			ipEntry = new IpAddressEntry(ipAddress);
			this._ipTable.Add(ipAddress, ipEntry);
		}

		return ipEntry;
	}

	public AddEntry(newIpEntry: IpAddressEntry): boolean {
		if (!newIpEntry || !newIpEntry.IpAddress)
			return false;

		return this._ipTable.Add(newIpEntry.IpAddress, newIpEntry);
	}

	public Clear(): void {
		this._ipTable.Clear();
	}

	public ClearMacAddress(ifIndex: number): void {
		this._ipTable.ForEach((pair) => {
			if (pair.Value.IfIndex == ifIndex) {
				pair.Value.MacAddress = null;
				pair.Value.IfIndex = -1;
			}
		});
	}

	public ContainsIpAddress(ipAddress: IpAddress): boolean {
		if (!ipAddress)
			return false;

		return this._ipTable.Some((pair) => {
			if (pair.Value.IpAddress && pair.Value.IpAddress.CompareTo(ipAddress))
				return true;
		});
	}

	public Clone(): IpAddressTable {
		var copyTable = new IpAddressTable(null);

		this._ipTable.ForEach((pair) => {
			var newEntry: IpAddressEntry = pair.Value.Clone();
			if (newEntry)
				copyTable.AddEntry(newEntry);
		});

		return (copyTable);
	}

	public get Count(): number {
		return this._ipTable.Count;
	}

	public get ValidDiscoveryAddressCount(): number {
		var count = 0;

		this._ipTable.ForEach((pair) => {
			if (pair.Value.IpAddress.IsValidDiscoveryAddress)
				count++;
		});

		return count;
	}

	public Find(ipAddress: IpAddress): IpAddressEntry {
		return this._ipTable.Item(ipAddress);
	}

	public FindByIfIndex(ifIndex: number): IpAddressEntry {
		var entry: IpAddressEntry = null;

		this._ipTable.ForEach((pair) => {
			if (pair.Value.IfIndex == ifIndex) {
				entry = pair.Value;
				return true;
			}
		});

		return entry;
	}

	public get HasIpAddresses(): boolean {
		return true;
	}

	public get IpAddresses(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._ipTable.ForEach((pair) => {
			if (pair.Value.IpAddress && pair.Value.IpAddress.IsValidDiscoveryAddress)
				ipAddresses.Add(pair.Value.IpAddress);
		});

		return (ipAddresses);
	}

	public get HasMacAddresses(): boolean {
		return true;
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._ipTable.ForEach((pair) => {
			if (pair.Value.MacAddress && pair.Value.MacAddress.IsValidAddress)
				macAddresses.Add(pair.Value.MacAddress);
		});

		return (macAddresses);
	}

	public Remove(ipAddress: IpAddress): boolean {
		return this._ipTable.Remove(ipAddress);
	}

	public RemoveEntry(ipEntry: IpAddressEntry): boolean {
		return ipEntry ? this._ipTable.Remove(ipEntry.IpAddress) : false;
	}

	public ForEach(callbackfn: (value: IpAddressEntry, index: number, array: IpAddressEntry[]) => void, thisArg?: any): void {
		this._ipTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: IpAddressEntry, index: number, array: IpAddressEntry[]) => boolean, thisArg?: any): boolean {
		return this._ipTable.Values().Some(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.ip_info = {};
		obj = obj.ip_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._ipTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_info)
			throw new Error();
		obj = obj.ip_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new IpAddressEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}